/**
 * Scenario 3 rule: a usable account must have a non-empty account_id and the account_type
 * must be 'sales_agency'. If the principal.user map has no entry, or the first entry fails
 * either check, the user is treated as deleted.
 *
 * subject.principal.user is expected to carry exactly one key/value pair; we inspect the
 * first value.
 */
export function isUsableSalesAgencyPrincipal(subject) {
    const user = Object.values(subject?.principal?.user || {})[0];
    return Boolean(user?.account_id) && user?.account_type === 'sales_agency';
}
